import RouteConfig from './config/RouteConfig';
import EditDriver from 'edge/quoteandbind/pa/directives/pa-edit-driver/PAEditDriver';
import EditVehicle from 'edge/quoteandbind/pa/directives/pa-edit-vehicle/PAEditVehicle';
import PAConfirmation from 'edge/quoteandbind/pa/directives/pa-confirmation/PAConfirmation';
import defaultVehicleCoverages from 'edge/quoteandbind/pa/directives/PaOfferingSelection/defaultQuoteView/defaultVehicleCoverages/defaultVehicleCoverages';
import defaultBaseCoverages from 'edge/quoteandbind/pa/directives/PaOfferingSelection/defaultQuoteView/defaultBaseCoverages/defaultBaseCoverages';

import paMobileCoverages from 'edge/quoteandbind/pa/directives/PaOfferingSelection/mobileQuoteView/mobileCoverages/mobileCoverages';
import paMobileCoveragesSummary from 'edge/quoteandbind/pa/directives/PaOfferingSelection/mobileQuoteView/mobileCoveragesSummary/mobileCoveragesSummary';

import 'edge/policyjob/services/VinLookupService';
import 'edge/policyjob/services/VehicleImageLookupService';
import 'edge/quoteandbind/common/app';
import 'edge/policyjob/app';
import 'edge/platform/widgets/time/module';
import 'angularRouter';

import DriverLicenseUtil from './util/DriverLicenseUtil';

export default angular.module('edge.quoteandbind.pa.app', ['edge.quoteandbind.common.app', 'edge.policyjob.app', 'edge.platform.widgets.ui.time']).config(['$stateProvider', 'state_plugin_config', function ($stateProvider, RootStateConfig) {
    var states = new RouteConfig(RootStateConfig);
    for (var stateName in states) {
        if (states.hasOwnProperty(stateName)) {
            $stateProvider.state(stateName, states[stateName]);
        }
    }
}]).filter('orderObjectBy', function () {
    return function (items, field, reverse) {
        var filtered = [];
        angular.forEach(items, function (item) {
            filtered.push(item);
        });
        filtered.sort(function (a, b) {
            /*eslint-disable */
            return a[field] > b[field] ? 1 : a[field] < b[field] ? -1 : 0;
            /*eslint-enable */
        });
        if (reverse) {
            filtered.reverse();
        }
        return filtered;
    };
}).factory('DriverLicenseUtil', DriverLicenseUtil).directive('gwQnbPaEditDriver', EditDriver).directive('gwQnbPaEditVehicle', EditVehicle).directive('gwQnbPaConfirmation', PAConfirmation).component('gwQnbDefaultVehicleCoverages', defaultVehicleCoverages).component('gwQnbDefaultPaBaseCoverages', defaultBaseCoverages).component('gwQnbPaMobileCoverages', paMobileCoverages).component('gwQnbPaMobileSummary', paMobileCoveragesSummary).constant('VinLookupEnabled', true).value('pa.qnb.editableDriverDOB', false);


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/conditional?if=quoteandbind_lob&equals=pa!./common/js/src/edge/quoteandbind/pa/app.js
// module id = 479
// module chunks = 0